import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { MdCreditCard } from "react-icons/md";
import { PlansModal } from "@/components/PlansModal";
import * as S from "./styles";

interface PlansChooserTypes extends React.ComponentPropsWithoutRef<'button'>{
  planHandler?: (plan: string) => void;
  showModal?: boolean;
}

export default function PlansChooser({ planHandler, showModal = false, ...props }: PlansChooserTypes) {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(showModal);

  const handlePlanSuccess = (planId: string) => {
    planHandler?.(planId);
    setModalOpen(false);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  return (
    <>
      <S.OurPlansWrapper>
        <h2>{t('payment.title')}</h2>
        <p>{t('payment.subtitle')}</p>
        
        <Button
          variant="contained"
          size="large"
          startIcon={<MdCreditCard />}
          onClick={handleOpenModal}
          disabled={props.disabled}
          sx={{
            background: 'linear-gradient(135deg, #49fbb0 0%, #36d399 100%)',
            color: '#183530',
            fontWeight: 600,
            py: 2,
            px: 4,
            fontSize: '1.1rem',
            borderRadius: '12px',
            textTransform: 'none',
            '&:hover': {
              background: 'linear-gradient(135deg, #36d399 0%, #2dd4aa 100%)',
              transform: 'translateY(-2px)',
              boxShadow: '0 8px 25px rgba(73, 251, 176, 0.3)'
            },
            '&:disabled': {
              background: 'rgba(73, 251, 176, 0.3)',
              color: 'rgba(24, 53, 48, 0.5)'
            }
          }}
        >
          Ver Planos Disponíveis
        </Button>
      </S.OurPlansWrapper>

      <PlansModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSuccess={handlePlanSuccess}
      />
    </>
  );
}
